import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const GuruForm = ({ token }) => {
  const [nama, setNama] = useState('');
  const [nip, setNip] = useState('');
  const [mapel, setMapel] = useState('');
  const [tglLahir, setTglLahir] = useState('');
  
  // BIODATA TAMBAHAN
  const [jenisKelamin, setJenisKelamin] = useState('L');
  const [noHp, setNoHp] = useState('');
  const [email, setEmail] = useState('');
  const [alamat, setAlamat] = useState('');

  const [mapelList, setMapelList] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchMapel();
    if (id) fetchGuru();
  }, [id]);

  const fetchMapel = async () => {
    try {
      const res = await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/mapel', { headers: { Authorization: `Bearer ${token}` } });
      setMapelList(res.data);
    } catch (err) {}
  };

  const fetchGuru = async () => {
    try {
      const res = await axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/guru/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = res.data;
      setNama(data.nama);
      setNip(data.nip);
      setMapel(data.mapel === '-' ? '' : data.mapel); // Kalau mapel '-', set jadi kosong di form
      setTglLahir(data.tgl_lahir);
      // Biodata
      setJenisKelamin(data.jenis_kelamin || 'L');
      setNoHp(data.no_hp || '');
      setEmail(data.email || '');
      setAlamat(data.alamat || '');
    } catch (err) {}
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { 
        nama, nip, mapel, 
        tgl_lahir: tglLahir,
        jenis_kelamin: jenisKelamin,
        no_hp: noHp,
        email,
        alamat
    };

    try {
      if (id) {
        await axios.put(`https://sijapan.sman10fajarharapan.sch.id/api/guru/${id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
        Swal.fire('Berhasil', 'Data guru diperbarui', 'success');
      } else {
        await axios.post('https://sijapan.sman10fajarharapan.sch.id/api/guru', payload, { headers: { Authorization: `Bearer ${token}` } });
        Swal.fire('Berhasil', 'Guru baru ditambahkan', 'success');
      }
      navigate('/guru');
    } catch (err) {
      Swal.fire('Gagal', 'Terjadi kesalahan sistem', 'error');
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '20px auto', padding: '30px', background: 'white', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
      <h2 style={{ color: '#334155', marginBottom: '25px', textAlign:'center' }}>{id ? '👨‍🏫 Edit Guru' : '➕ Tambah Guru Baru'}</h2>
      <form onSubmit={handleSubmit}>
        
        {/* INFO KEPEGAWAIAN */}
        <h4 style={{borderBottom:'2px solid #f1f5f9', paddingBottom:'10px', color:'#4361ee'}}>💼 Info Kepegawaian</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
                <label style={labelStyle}>NIP (Username Login)</label>
                <input type="text" value={nip} onChange={e => setNip(e.target.value)} required style={inputStyle} />
            </div>
            <div>
                <label style={labelStyle}>Nama Lengkap & Gelar</label>
                <input type="text" value={nama} onChange={e => setNama(e.target.value)} required style={inputStyle} />
            </div>
            
            {/* INPUT MAPEL (OPSIONAL) */}
            <div>
                <label style={labelStyle}>Mata Pelajaran Utama</label>
                <select 
                    value={mapel} 
                    onChange={e => setMapel(e.target.value)} 
                    style={inputStyle} // 'required' SUDAHDIHAPUS
                >
                    <option value="">-- Pilih Mapel (Opsional) --</option>
                    <option value="-">⛔ Tidak Mengajar / Struktural</option>
                    {mapelList.map(m => (
                        <option key={m.id} value={m.nama_mapel}>{m.nama_mapel}</option>
                    ))}
                </select>
                <small style={{color:'#64748b', fontSize:'11px', fontStyle:'italic'}}>*Pilih "Tidak Mengajar" untuk Kepsek/Staff.</small>
            </div>

            <div>
                <label style={labelStyle}>Tanggal Lahir (Password Default)</label>
                <input type="date" value={tglLahir} onChange={e => setTglLahir(e.target.value)} required style={inputStyle} />
            </div>
        </div>

        {/* BIODATA & KONTAK */}
        <h4 style={{borderBottom:'2px solid #f1f5f9', paddingBottom:'10px', color:'#4361ee', marginTop:'30px'}}>📞 Kontak & Biodata</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
                <label style={labelStyle}>Jenis Kelamin</label>
                <select value={jenisKelamin} onChange={e => setJenisKelamin(e.target.value)} style={inputStyle}>
                    <option value="L">Laki-laki</option>
                    <option value="P">Perempuan</option>
                </select>
            </div>
            <div>
                <label style={labelStyle}>No. HP / WA</label>
                <input type="text" value={noHp} onChange={e => setNoHp(e.target.value)} style={inputStyle} />
            </div>
            <div style={{ gridColumn: 'span 2' }}>
                <label style={labelStyle}>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={inputStyle} />
            </div>
            <div style={{ gridColumn: 'span 2' }}>
                <label style={labelStyle}>Alamat Lengkap</label>
                <textarea value={alamat} onChange={e => setAlamat(e.target.value)} rows="2" style={{...inputStyle, height:'auto'}}></textarea>
            </div>
        </div>

        <div style={{ display: 'flex', gap: '10px', marginTop: '30px' }}>
            <button type="submit" style={{ flex: 1, padding: '12px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor:'pointer' }}>💾 Simpan Data</button>
            <button type="button" onClick={() => navigate('/guru')} style={{ flex: 1, padding: '12px', background: '#e2e8f0', color: '#334155', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor:'pointer' }}>Batal</button>
        </div>
      </form>
    </div>
  );
};

const labelStyle = { display: 'block', marginBottom: '8px', fontWeight: '600', color: '#64748b', fontSize:'14px' };
const inputStyle = { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', boxSizing:'border-box' };

export default GuruForm;